import { isBuddhistYear, christianToThaiWithoutFormat, dateFormat, dateToMoment } from 'core/service/lib/date'

const formatPassword = (birthdate) => birthdate.replace(/\//g, '')

export const generatePassword = (birthdate) => {
  let date = birthdate
  if (!isBuddhistYear(birthdate)) {
    date = christianToThaiWithoutFormat(dateToMoment(birthdate).format('MM/DD/YYYY')).format(dateFormat)
  }

  return formatPassword(date)
}
